import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { selectIsSmallScreen } from 'store/pageStore';
import { BoldTitle, Container } from 'common/components';
import { AdvantagesCards, AdvantagesSection } from './components';

import { headerStyles } from './styles';

export const Advantages = () => {
	const isSmallScreen = useSelector(selectIsSmallScreen);

	return (
		<AdvantagesSection>
			<Container>
				<Typography
					className={`${headerStyles} ${BoldTitle}`}
					variant={isSmallScreen ? 'h2' : 'h1'}
					as="h2"
					overrideStyles={false}
				>
					Надёжный и&nbsp;удобный сервис Лемана ПРО
				</Typography>
				<AdvantagesCards />
			</Container>
		</AdvantagesSection>
	);
};
